// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ClassStep from "./class-step.js"
import Highscore from "./highscore.js"
import Organization from "./organization.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "class_step_id": {
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": false,
        "type": "uuid"
      },
      "name": "class_step_id",
      "selected_by_default": null,
      "translated": null
    },
    "highscore_id": {
      "column": {
        "default": null,
        "name": "highscore_id",
        "null": false,
        "type": "uuid"
      },
      "name": "highscore_id",
      "selected_by_default": null,
      "translated": null
    },
    "min_per_class_step": {
      "column": {
        "default": null,
        "name": "min_per_class_step",
        "null": true,
        "type": "integer"
      },
      "name": "min_per_class_step",
      "selected_by_default": null,
      "translated": null
    },
    "region_id": {
      "column": {
        "default": null,
        "name": "region_id",
        "null": true,
        "type": "uuid"
      },
      "name": "region_id",
      "selected_by_default": null,
      "translated": null
    },
    "team_type": {
      "column": {
        "default": null,
        "name": "team_type",
        "null": true,
        "type": "string"
      },
      "name": "team_type",
      "selected_by_default": null,
      "translated": null
    },
    "translated_team_type": {
      "column": null,
      "name": "translated_team_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "HighscoreClassStep",
  "collectionKey": "highscore_class_steps",
  "collectionName": "highscore_class_steps",
  "i18nKey": "highscore_class_step",
  "camelizedLower": "highscoreClassStep",
  "name": "HighscoreClassStep",
  "nameDasherized": "highscore-class-step",
  "pluralName": "highscore_class_steps",
  "ransackable_associations": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "belongs_to",
      "resource_name": "Highscore",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "region_id",
      "name": "region",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "class_step_id",
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "highscore_id",
      "column": {
        "default": null,
        "name": "highscore_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "min_per_class_step",
      "column": {
        "default": null,
        "name": "min_per_class_step",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_class_step_id",
      "column": {
        "default": null,
        "name": "old_class_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_highscore_id",
      "column": {
        "default": null,
        "name": "old_highscore_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_region_id",
      "column": {
        "default": null,
        "name": "old_region_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "region_id",
      "column": {
        "default": null,
        "name": "region_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "team_type",
      "column": {
        "default": null,
        "name": "team_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "belongs_to",
      "resource_name": "Highscore",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "region_id",
      "name": "region",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    }
  ],
  "paramKey": "highscore_class_step",
  "primaryKey": "id"
}

/** Frontend model for HighscoreClassStep. */
export default class HighscoreClassStep extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  classStepId() {
    return this.readAttributeUnderscore("class_step_id")
  }

  /** @returns {boolean} */
  hasClassStepId() {
    const value = this.classStepId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  highscoreId() {
    return this.readAttributeUnderscore("highscore_id")
  }

  /** @returns {boolean} */
  hasHighscoreId() {
    const value = this.highscoreId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  minPerClassStep() {
    return this.readAttributeUnderscore("min_per_class_step")
  }

  /** @returns {boolean} */
  hasMinPerClassStep() {
    const value = this.minPerClassStep()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  regionId() {
    return this.readAttributeUnderscore("region_id")
  }

  /** @returns {boolean} */
  hasRegionId() {
    const value = this.regionId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  teamType() {
    return this.readAttributeUnderscore("team_type")
  }

  /** @returns {boolean} */
  hasTeamType() {
    const value = this.teamType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedTeamType() {
    return this.readAttributeUnderscore("translated_team_type")
  }

  /** @returns {boolean} */
  hasTranslatedTeamType() {
    const value = this.translatedTeamType()

    return this._isPresent(value)
  }

  /** @returns {import("./class-step.js").default | null} */
  classStep() {
    return this._readBelongsToReflection({modelClass: ClassStep, reflectionName: "class_step"})
  }

  /** @returns {Promise<import("./class-step.js").default | null>} */
  loadClassStep() {
    if (!("classStepId" in this)) throw new Error("Foreign key method wasn't defined: classStepId")

    const id = this.classStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "class_step",
        model: this,
        modelClass: ClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./class-step.js").default | null>} */
  ensureClassStepLoaded() {
    return this.ensureAssociationLoaded("class_step")
  }

  /** @returns {import("./highscore.js").default | null} */
  highscore() {
    return this._readBelongsToReflection({modelClass: Highscore, reflectionName: "highscore"})
  }

  /** @returns {Promise<import("./highscore.js").default | null>} */
  loadHighscore() {
    if (!("highscoreId" in this)) throw new Error("Foreign key method wasn't defined: highscoreId")

    const id = this.highscoreId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "highscore",
        model: this,
        modelClass: Highscore
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./highscore.js").default | null>} */
  ensureHighscoreLoaded() {
    return this.ensureAssociationLoaded("highscore")
  }

  /** @returns {import("./organization.js").default | null} */
  region() {
    return this._readBelongsToReflection({modelClass: Organization, reflectionName: "region"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadRegion() {
    if (!("regionId" in this)) throw new Error("Foreign key method wasn't defined: regionId")

    const id = this.regionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "region",
        model: this,
        modelClass: Organization
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureRegionLoaded() {
    return this.ensureAssociationLoaded("region")
  }
}
